import { render } from "./HelpWrap.vue?vue&type=template&id=0628b987&scoped=true"
const script = {}

import "./HelpWrap.vue?vue&type=style&index=0&id=0628b987&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0628b987"]])

export default __exports__